
import { MapTo } from '@adobe/aem-react-editable-components';
import MultiCardModule, { MultiCardModuleEditConfig } from './MultiCardModule';

export default MapTo('cob-corp-acquisition/components/creditonebank/multi-card-module')(MultiCardModule, MultiCardModuleEditConfig);
        